__turbopack_context__.v({
  "anchor": "Headline-module__5IcXZG__anchor",
  "anchorReveal": "Headline-module__5IcXZG__anchorReveal",
  "headline": "Headline-module__5IcXZG__headline",
});
